import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight'
import { IPolicy } from '@verzekeringapp-mono/shared/src/models/policy'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getProductIcons } from '@verzekeringapp-mono/shared/src/state/selectors/policies'
import { getPolicySummary } from '../utils/policy_summary'

const currency = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' })

interface Props {
  policy: IPolicy
  isUnexpelled?: boolean
}

const PolicySummaryRow: React.FC<Props> = ({ policy, isUnexpelled = true }) => {
  const productIcons = useAppSelector(getProductIcons)
  const content = (
    <>
      <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${isUnexpelled ? 'bg-surface-brand-subtle' : 'bg-surface-card'}`}>
        <FontAwesomeIcon
          icon={productIcons[policy.productId] || 'file-lines'}
          className={isUnexpelled ? 'text-icon-brand' : 'text-icon-secondary'}
        />
      </div>

      <div className='min-w-0 flex-1'>
        <p className='text-sm font-semibold'>{policy.productName}</p>

        <p className='text-sm'>{getPolicySummary(policy)}</p>
      </div>

      <div className='shrink-0 text-right'>
        {isUnexpelled && policy.status === 'Lopend' && policy.premium && (
          <>
            <p className='text-sm font-semibold'>{currency.format(Number(policy.premium))}</p>

            {policy.paymentMethod === 'one_time' && <p className='text-xs'>eenmalig</p>}
          </>
        )}

        {policy.status !== 'Lopend' && <p className='text-sm text-text-muted'>{policy.status}</p>}
      </div>

      {isUnexpelled && (
        <FontAwesomeIcon
          icon={faChevronRight}
          className='ml-1 shrink-0 text-icon-secondary'
        />
      )}
    </>
  )

  return isUnexpelled
    ? (
      <Link
        to={`/verzekeringen/polis/${policy.id}`}
        className='flex items-center gap-3 px-3 py-3 transition-colors hover:bg-surface-hover focus-visible:bg-surface-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-border-focus'
      >
        {content}
      </Link>
    )
    : (
      <div className='flex items-center gap-3 bg-surface-card-disabled px-3 py-3'>
        {content}
      </div>
    )
}

export default PolicySummaryRow
